export default "__VITE_ASSET__B$1d89k5__"